<template>
  <div>
    <b-col cols="12" class="mb-4">
      <PageTitle title="Pesquisa(s) realizadas no Site/App" />
    </b-col>

    <b-col cols="12" class="mb-4">
      <PeriodsFilters
        ref="periodsFilters"
        :setDatesAutomatic="false"
        :startDate.sync="startDate"
        :endDate.sync="endDate"
        @click.native="get()"
      />
    </b-col>

    <b-col
      cols="12"
      class="mt-5 mb-2 d-flex align-items-center justify-content-between"
    >
      <h3>Encontrado {{ pagination.total }} buscas</h3>

      <b-button
        v-if="!generatingSpreadsheet"
        pill
        variant="success"
        @click="generateSpreadsheet()"
      >
        <i class="fas fa-file-download mr-2"></i>
        Baixar planilha
      </b-button>
      <b-spinner v-else variant="success" label="Spinning"></b-spinner>
    </b-col>

    <b-col>
      <b-table
        striped
        hover
        responsive
        :fields="table.headers"
        :items="table.records"
        :busy="loading"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>

        <template #cell(search)="data">
          {{ data.item.search }}
        </template>

        <template #cell(appWeb)="data">
          {{ data.item.appWeb }}
        </template>

        <template #cell(name)="data">
          {{ data.item.name }}
        </template>

        <template #cell(email)="data">
          {{ data.item.email }}
        </template>

        <template #cell(document)="data">
          {{ data.item.document }}
        </template>

        <template #cell(phone)="data">
          {{ data.item.phone }}
        </template>

        <template #cell(createdAt)="data">
          {{ data.item.createdAt }}
        </template>
      </b-table>
    </b-col>

    <b-col cols="12" class="d-flex align-items-center justify-content-center">
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.itemsPerPage"
        :disabled="loading"
      ></b-pagination>
    </b-col>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import PageTitle from '../../../components/PageTitle.vue';
import makeToast from '../../../mixins/makeToast';
import PeriodsFilters from '@/components/Inputs/PeriodsFilters.vue';
import * as XLSX from 'xlsx';
import UserTypes from '@/enums/UserTypes';

export default {
  name: 'ProductSearch',
  mixins: [makeToast],
  components: {
    PageTitle,
    PeriodsFilters,
  },

  watch: {
    'pagination.currentPage': function () {
      this.get();
    },
  },

  data() {
    return {
      loading: false,
      generatingSpreadsheet: false,
      pagination: {
        currentPage: 1,
        itemsPerPage: 200,
        total: 0,
      },
      startDate: '',
      endDate: '',
      table: {
        headers: [
          {
            key: 'search',
            label: 'Busca',
          },
          {
            key: 'appWeb',
            label: 'App/Site',
          },
          {
            key: 'name',
            label: 'Cliente',
          },
          {
            key: 'email',
            label: 'E-mail',
          },
          {
            key: 'document',
            label: 'Documento',
          },
          {
            key: 'phone',
            label: 'Telefone(s)',
          },
          {
            key: 'createdAt',
            label: 'Buscado em:',
          },
        ],
        records: [],
      },
    };
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  mounted() {
    this.get();
  },

  methods: {
    ...mapActions('shopkeeper', ['getProductSearchInput']),

    get() {
      this.limpar = false;
      (this.loading = true), this.$store.dispatch('startLoader');

      this.getProductSearchInput({
        userId: this.userTypeId(),
        currentPage: this.pagination.currentPage,
        startDate: this.startDate || '',
        endDate: this.endDate || '',
      })
        .then((response) => {
          const results = response.data.data;
          this.pagination.total = results.total || 0;
          this.pagination.currentPage = results.currentPage;
          this.pagination.itemsPerPage = results.perPage || 200;
          this.table.records = results.data;
        })
        .finally(() => {
          this.loading = false;
          this.$store.dispatch('endLoader');
        });
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
    generateSpreadsheet() {
      this.generatingSpreadsheet = true;

      const clientsData = XLSX.utils.json_to_sheet(
        this.convertColumnsNames(this.table.records)
      );
      const excelFile = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(excelFile, clientsData, 'Lista de buscas');

      const currentDate = new Date().toLocaleDateString('pt-BR');
      const nomeFantasia =
        this.$route.meta.userType == UserTypes.BALCONISTA
          ? this.dadosUsuario.lojista.nome_fantasia
          : this.dadosUsuario.informacoes.nome_fantasia;

      const fileName = `Lista de buscas - ${nomeFantasia} - ${currentDate}`;

      setTimeout(() => {
        this.generatingSpreadsheet = false;
      }, 1000);

      XLSX.writeFile(excelFile, `${fileName}.xlsx`);
    },
    /**
     * @param {Array} records
     * @returns {Array}
     */
    convertColumnsNames(records) {
      if (!records || !records.length) return [];

      const returnArray = [];

      records.forEach((record) => {
        const cell = {};
        Object.keys(record).forEach((key) => {
          const tableColumn = this.table.headers.find((x) => x.key === key);
          if (tableColumn) cell[`${tableColumn.label}`] = record[key];
        });

        returnArray.push(cell);
      });

      return returnArray;
    },
  },
};
</script>
